module.exports = __webpack_public_path__ + "img/01-1.c759c6c3.gif";